import { Component, OnInit } from '@angular/core';
import { UiService } from '../ui.service';
import { AppServiceService } from '../app-service.service';
import { qualityAnimatePage } from '../animation/animate';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-quality',
  templateUrl: './quality.component.html',
  styleUrls: ['./quality.component.scss'],
  animations: [qualityAnimatePage],
  host: { '[@qualityAnimatePage]': '' }
})
export class QualityComponent implements OnInit {
  private ngUnsubscribe: Subject<boolean> = new Subject();
  private post:any;
  public theme:any = {
    'social' : {
      'facebook' : '',
      'instagram': ''
    }
  };
  public screen:any = {
    'width' : '1920',
    'height': '1080'
  };

  cursorX:any = '50%';
  cursorY:any = '50%';

  constructor(
    private UI: UiService, 
    private app: AppServiceService,
    private route: ActivatedRoute
  ) {
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.post = data.data;
      this.theme  = data.theme;
    });
    this.app.blackStyle.next(false);
    this.cursorX = this.app.cursorX;
    this.cursorY = this.app.cursorY;
    
    //that menu show in app
    this.app.normalMenu.next(true);
   }

   
  /**
 * get format file in slide
 */
  getFormSlide(file){
    let regex = /\b\.jpg|\b\.png|\b.jpeg/ig;
    return regex.test(file);
  }

  /**
   * get url video
   */
  getUrlVideo(url_video, url_main, emded){
    return emded != '' ? url_video : url_main;
  }

  /**
   * get url format
   */
  getUrlFormat(url_video, url_main, emded){
    return emded != '' ? 'video/youtube' : 'video/'+url_main.split('.')[url_main.split('.')- 1];
  }

  ngOnInit() {
    //screen
    this.screen = this.app.screen;
    this.app.screenSubject.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.screen = this.app.screen;
    })

    setTimeout(() => {
      this.app.title.next(this.post.title);
    }, 500)
    setTimeout(() => {
      this.app.titleLeftPanel.next(true);
      this.app.showLeftPanel.next(true);
      //show arrow left panel
      this.app.arrow.next(true);
      //active animate 
      this.app.activeMenu.next(true);
      //run video
      this.UI.mediaScript();
    }, 2000);
  }

  ngOnDestroy(){
    this.app.titleLeftPanel.next(false);
    this.app.activeMenu.next(false);
    this.app.menuState.next('hide');
    this.app.submenuState.next('hide');

    setTimeout(() => {
      this.app.title.next('');
    }, 500);
    
    //unsabscribe
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/quality/quality.component.ts